import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";

export class supplyAccountsMultiSelectCtrl implements IController {

  selectedIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  onChange: Function;

  private accountsRef: any;
  public selectedAccounts: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $accounts: $accountsFactory, private $element) {
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this._setSelectedAccounts();
  };

  $onChanges(changes) {
    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()){
      this._setSelectedAccounts();
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()){
      this._setSelectedAccounts();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'carriers';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({ids: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], accounts: []});
  }

  private _setSelectedAccounts() {
    if (!!this.selectedIds) {
      this.accountsRef.$asyncValues(this.selectedIds)
        .then((accounts) => {
          this.selectedAccounts = _.orderBy(accounts, ['name'], ['asc']);
          this._setSelectedText();
        });
    }else {
      this.selectedAccounts = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedAccounts, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedAccounts.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedAccounts[0].name + ` +${this.selectedAccounts.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountsMultiSelect', {
    bindings: {
      selectedIds: '<?',
      isBusiness: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./supply-accounts-multi-select.html').default,
    controller: supplyAccountsMultiSelectCtrl
  });
